module.exports = __webpack_public_path__ + "img/payment_success.23620af6.png";